import classNames from 'classnames'
import { noop, numberSeparatedWithComma } from 'utils'
import PropTypes from 'prop-types'

import { subjectTypes } from 'features/creative/add/asset/subjectSlice'
import { rangeTypes } from 'features/creative/add/asset/priceTableSlice'
import { Assets } from 'features/Codes'
import NoneAnchor from 'components/NoneAnchor'

export const AssetClassNames = {
  THUMBNAIL: {
    ...Assets.THUMBNAIL,
    className: 'thumbnail',
  },
  MULTI_THUMBNAIL: {
    ...Assets.MULTI_THUMBNAIL,
    className: 'multithumbnail',
  },
  ADDITIONAL_TITLE: {
    ...Assets.ADDITIONAL_TITLE,
    className: 'addsubject',
  },
  ADDITIONAL_LINK: {
    ...Assets.ADDITIONAL_LINK,
    className: 'addlink',
  },
  SUBJECT: {
    ...Assets.SUBJECT,
    className: 'addheadtxt',
  },
  PRICE_TABLE: {
    ...Assets.PRICE_TABLE,
    className: 'paytable',
  },
  CALCULATE: {
    ...Assets.CALCULATE,
    className: 'addsum',
  },
  PHONE_NUMBER: {
    ...Assets.PHONE_NUMBER,
    className: 'addtel',
  },
  TALK_CHANNEL: {
    ...Assets.TALK_CHANNEL,
    className: 'ktalk',
  },
  THUMBNAIL_RECOMMEND: {
    ...Assets.THUMBNAIL_RECOMMEND,
    className: 'talkch',
  },
  THUMBNAIL_CUSTOM: {
    ...Assets.THUMBNAIL_CUSTOM,
    className: 'talkch type_advanced',
  },
}

export const TabView = ({ isMobileView, onClickPc, onClickMobile }) => (
  <ul className="tab_view">
    <li className={classNames({ on: isMobileView })}>
      <NoneAnchor className="link_tab" onClick={onClickMobile}>
        모바일
      </NoneAnchor>
    </li>
    <li className={classNames({ on: !isMobileView })}>
      <NoneAnchor className="link_tab" onClick={onClickPc}>
        PC
      </NoneAnchor>
    </li>
  </ul>
)

export const Ktalk = () => (
  <span className={classNames('ad_talk', { ad_addch: false })}>
    {' '}
    <span className="ico_talk ico_ktalk">카카오톡 문의</span>
  </span>
)

export const AdHeadText = ({ kind, text }) => (
  <div className="ad_headtxt">
    <span className="txt_badge">
      {subjectTypes.find(type => type.id === kind)?.name || '말머리'}
    </span>
    <span className="txt_headtxt">{text || '내용'}</span>
  </div>
)

export const ListPay = ({ priceTables = [] }) => (
  <>
    {priceTables.map(({ text, price, range }, index) => {
      if (index > 0 && !text) {
        return null
      }
      return (
        <ul key={index} className="list_pay">
          <span className="txt_pay">
            {(price ? numberSeparatedWithComma(price.toString()) : '0') +
              rangeTypes.find(t => t.id === range).name}
          </span>
          <div className="box_pay">
            <span className="txt_pay">{text || '내용'}</span>
            <span className="txt_line" />
          </div>
        </ul>
      )
    })}
  </>
)

export const AdSublink = ({ links = [] }) => (
  <ul className="ad_sublink">
    {links.map(({ text }, index) => {
      if (index === 3 && !text) {
        return null
      }
      return (
        <li key={index}>
          <div className="link_sub">{text || `내용${index + 1}`}</div>
        </li>
      )
    })}
  </ul>
)

export const AdThumb = ({
  url,
  alt,
  thumbInfo,
  setMouseOver = noop,
  width,
}) => (
  <div className="ad_thumb">
    <span
      className="inner_thumb"
      onMouseOver={() => setMouseOver(true)}
      onMouseLeave={() => setMouseOver(false)}>
      <span className="thumb_bg">
        {url && <img src={url} width={width} className="img_thumb" alt={alt} />}
      </span>
      {thumbInfo && (
        <span className="thumb_info">
          <span className="ico_comm" />3
        </span>
      )}
    </span>
  </div>
)

export const ListThumb = ({ thumbnails = [] }) => (
  <ul className="list_thumb">
    {thumbnails.map((thumbnail, index) => (
      <li key={index}>
        <AdThumb
          url={thumbnail.url}
          alt={thumbnail.alt || '썸네일이미지'}
          width={104}
        />
        <span className="txt_thumb">{thumbnail.alt || `내용${index + 1}`}</span>
      </li>
    ))}
  </ul>
)

export const LayerMultiThumbnail = ({
  thumbnails = [],
  isMouseOver,
  setMouseOver,
}) => (
  <div
    className="layer_multithumbnail"
    onMouseEnter={() => setMouseOver(true)}
    onMouseLeave={() => setMouseOver(false)}
    style={isMouseOver ? { display: 'block' } : { display: 'none' }}>
    <ul className="list_thumb">
      {thumbnails.map((thumbnail, index) => (
        <li key={index}>
          <div className="ad_thumb">
            <span className="inner_thumb">
              <span className="thumb_bg">
                {thumbnail.url && (
                  <img
                    src={thumbnail.url}
                    width="116"
                    className="img_thumb"
                    alt={thumbnail.alt}
                  />
                )}
              </span>
            </span>
          </div>
          <span className="txt_thumb">
            {thumbnail.alt || `내용${index + 1}`}
          </span>
        </li>
      ))}
    </ul>
  </div>
)

TabView.propTypes = {
  isMobileView: PropTypes.bool.isRequired,
  onClickPc: PropTypes.func.isRequired,
  onClickMobile: PropTypes.func.isRequired,
}

AdHeadText.propTypes = {
  kind: PropTypes.string,
  text: PropTypes.string,
}

ListPay.propTypes = {
  priceTables: PropTypes.arrayOf(
    PropTypes.shape({
      price: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
      text: PropTypes.string,
      range: PropTypes.string,
    })
  ).isRequired,
}

AdSublink.propTypes = {
  links: PropTypes.arrayOf(
    PropTypes.shape({
      description: PropTypes.string,
    })
  ).isRequired,
}

AdThumb.propTypes = {
  url: PropTypes.string,
  alt: PropTypes.string,
  thumbInfo: PropTypes.bool,
  setMouseOver: PropTypes.func,
  width: PropTypes.number,
}

const MultiThumbnailPropType = {
  thumbnails: PropTypes.arrayOf(
    PropTypes.shape({
      image: PropTypes.shape({
        url: PropTypes.string,
      }),
      description: PropTypes.string,
    })
  ).isRequired,
}

ListThumb.propTypes = MultiThumbnailPropType

LayerMultiThumbnail.propTypes = {
  ...MultiThumbnailPropType,
  isMouseOver: PropTypes.bool,
  setMouseOver: PropTypes.func.isRequired,
}
